import { render, staticRenderFns } from "./InvoiceDetailSummaryItemsTable.vue?vue&type=template&id=5f5d1684&"
import script from "./InvoiceDetailSummaryItemsTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetailSummaryItemsTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetailSummaryItemsTable.vue?vue&type=style&index=0&id=5f5d1684&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports